import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@wa/shared';
import { App } from '@/app/App';
import '../../packages/shared/src/styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // On, and it was wrong to switch it off. The reasoning was "the hub says when
      // something changed, so background refetching is duplicate load" — true only
      // while the hub is connected, and every screen but the inbox has no hub at
      // all. Coming back to a tab that was in the background for an hour and being
      // shown an hour-old list is not a saving.
      //
      // staleTime keeps it cheap: a tab regaining focus refetches at most once every
      // thirty seconds per query, and not at all if nothing has gone stale.
      refetchOnWindowFocus: true,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider portal="client">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
